import React from "react";
import { Paper, Typography } from "@mui/material";

export default function CircleActivitySummary({ circle }) {
  if (!circle) {
    return (
      <Typography variant="body2" sx={{ color: "#7b8799" }}>
        No Accountability activity to show for this week.
      </Typography>
    );
  }

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: "8px",
        p: 2,
        border: "1px solid #e8eef6",
        backgroundColor: "#f9fbff",
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#15243b" }}>
        {circle.partner_name}
      </Typography>
      <Typography variant="body2" sx={{ mt: 0.4, color: "#6f7f95" }}>
        {circle.body}
      </Typography>
    </Paper>
  );
}
